import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import NumberAnimator from '../../../components/ui/NumberAnimator'
import { getWizardV2State } from '../wizardService';
import { setLastChangedFilter } from '../../../appSlice';
import { setWizardDesktop, setMobileHomepage } from '../onboardingSlice';
import useGetWelcomeMessage from '../../../hooks/wizard/useGetWelcomeMessage';
import { isEntryFlow, removeParamFromUrl } from '../../../utilities/urlResolver';
import { t } from '../../../utilities/translator';
import { setSecondaryFilterDefault } from '../../secondaryFilter/secondaryFilterSlice';
import { setMainFilterDefault } from '../../mainFilter/mainFilterSlice';
import { pushEvent } from '../../../utilities/analytics';
import { ONBOARDING_SKIP_HOME_EVENT, ONBOARDING_START_WIZARD_V2_EVENT } from '../../../constants/analyticEvents';
import { selectFiltersLoaded } from '../../mainFilter/selectors';

// Used only in desktop wizard
const WelcomeStepFooter = ({
  startWizard,
}) => {
  const dispatch = useDispatch();
  const { counterText, showCounter } = getWizardV2State().welcomeStep;
  const filtersReady = useSelector(selectFiltersLoaded);
  const showSkipButton = true;
  const hfLastFilters = JSON.parse(localStorage.getItem('hfLastFilters'));
  const startButton = hfLastFilters ? t('onboarding.startWizardReturning') : t('onboarding.startWizardNew');

  const { subtitleText } = useGetWelcomeMessage()

  const onStartClick = () => {
    window.scrollTo(0, 0, { behavior: 'smooth' });
    startWizard();

    if (window.pr_welcome) {
      pushEvent(ONBOARDING_START_WIZARD_V2_EVENT, { welcomePresets: window.pr_welcomeScreenToLoad });
    } else {
      pushEvent(ONBOARDING_START_WIZARD_V2_EVENT);
    }
  }

  const onSkipClick = () => {
    if (isEntryFlow('link-presets') || isEntryFlow('link-presets-welcome')) {
      removeParamFromUrl(['pr_entryFlow']);
    }
    pushEvent(ONBOARDING_SKIP_HOME_EVENT, { skipFrom: 'welcome' });
    dispatch(setLastChangedFilter('what'));
    dispatch(setSecondaryFilterDefault());
    dispatch(setMainFilterDefault());
    dispatch(setWizardDesktop(false));
    dispatch(setMobileHomepage(false));
  }

  return (
    <div className="welcome-screen welcome-screen-desktop">
      <div className="flex flex-col items-center gap-10 text-center">
        <div className="text-white">
          {showCounter && !isEntryFlow('link-presets-welcome') && (
            <div className="animated-counter mb-3">
              <NumberAnimator number={window.holidayFinder?.welcomeScreenCounter[window.holidayFinder.market]} />
            </div>
          )}
          {!isEntryFlow('link-presets-welcome') && <div className="text-lg leading-6">{counterText}</div>}
          {subtitleText && <h1 className="welcome-screen-entry-text mt-8 mb-0">{subtitleText}</h1>}
        </div>
        <div className="buttons-list animated fadeIn">
          <button className="welcome-screen-btn btn-start text-xl font-semibold leading-none flex items-center justify-center gap-2 rounded-full" onClick={onStartClick}>
            {startButton}
            <i className="ri-arrow-right-s-line text-2xl leading-none rtl:-scale-x-100" />
          </button>
          <button className={cn('welcome-screen-btn welcome-screen-btn__skip heading-tiny leading-none', { 'invisible opacity-0': !showSkipButton || !filtersReady })} onClick={onSkipClick}>
            {t('onboarding.skipWizard')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default WelcomeStepFooter
